<template>
  <div>
    <div class="row">
      <div class="col-7">
        <div v-if="show_logo" style="position: relative">
          <div class="d-flex justify-content-center" :class="icon ? 'navbar-logo-container' : 'navbar-bolsa-container'">
            <img @click="goHome()" v-if="icon" class="logo-store" src="@/assets/store/home/svglogo.svg" alt="">
          </div>
        </div>
      </div>
      <div class="col-5 d-flex justify-content-end" style="padding-bottom: 0 !important">
        <v-menu
          v-model="menu_open"
          :nudge-width="400"
          :close-on-content-click="false"
          rounded="lg"
          v-if="nav"
          origin="center center"
          transition="scale-transition"
          nudge-top="150"
        >
          <template v-slot:activator="{ on, attrs }" >
            <v-btn
              dark
              icon
              v-bind="attrs"
              v-on="on"
              class="mr-5"
            >
              <v-icon size="40" color="accent">mdi-menu</v-icon>
            </v-btn>
            <!--<div class="d-flex justify-content-end px-4">
              <div style="position: relative;">
                <img
                  v-bind="attrs"
                  v-on="on"
                  style="width: 50px; max-width: 50px; height: 48px; max-height: 50px"
                  src="@/assets/store/home/usernv.gif"
                  alt=""
                >
              </div>
            </div>-->
          </template>

          <v-card>
            <v-toolbar
              dense
              color="accent"
              dark
              elevation="0"
            >
              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="menu_open = false"
                class="mr-1"
              >
                <v-icon size="40" color="light">mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-list color="accent" style="padding: 0 0 50px 0 !important">

              <!--grupo de items nosotros-->
              <v-list-item>
                <v-list-group
                  no-action
                  sub-group
                  color="light"
                >
                  <template v-slot:activator>
                    <v-list-item-title>
                      <b>NOSOTROS</b>
                    </v-list-item-title>
                  </template>

                  <v-list-item dense to="/nuestra-historia">
                    <b>Historia</b>
                  </v-list-item>

                  <v-list-item dense to="/colaboraciones">
                    <b>Colaboraciones</b>
                  </v-list-item>

                </v-list-group>
              </v-list-item>

              <!--grupo de items productos-->
              <v-list-item>
                <v-list-group
                  no-action
                  sub-group
                  color="white"
                >
                  <template v-slot:activator>
                    <v-list-item-title>
                      <b>HELADOS</b>
                    </v-list-item-title>
                  </template>

                  <v-list-item dense to="/lista/productos/todos/t">
                    <b>Todos</b>
                  </v-list-item>

                  <v-list-item
                    dense
                    @click="menu_open = false"
                    v-for="cat of data_home_page.categories_flavors"
                    :key="cat.id"
                    :to="`/lista/productos/${cat.key_}/${cat.id}`"
                  >
                    <b>{{ cat.name }}</b>
                  </v-list-item>

                </v-list-group>
              </v-list-item>

              <!--grupo de items contacto-->
              <v-list-item>
                <v-list-group
                  no-action
                  sub-group
                  color="white"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <b>CONTACTO</b>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item dense to="/sucursales">
                    <b>Sucursales</b>
                  </v-list-item>
                  <v-list-item dense to="/politicas-privacidad">
                    <b>Legal</b>
                  </v-list-item>
                </v-list-group>
              </v-list-item>

              <!--grupo de items autenticacion-->
              <v-list-item>
                <v-list-group
                  no-action
                  sub-group
                  color="white"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <b>CUENTA</b>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item v-if="!is_auth" dense to="/iniciar-sesion">
                    <b>Iniciar sesión</b>
                  </v-list-item>
                  <v-list-item v-if="!is_auth" dense to="/registro">
                    <b>Registrarme</b>
                  </v-list-item>

                  <v-list-item v-if="is_auth" dense to="/mi-cuenta">
                    <b>Perfil</b>
                  </v-list-item>
                  <v-list-item :disabled="inactive_item" v-if="is_auth" dense @click="logout">
                    <b>Salir</b>
                  </v-list-item>

                </v-list-group>
              </v-list-item>

            </v-list>
          </v-card>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HomeService from '@/services/home.service'

export default {
  name: 'Navbar',
  props: {
    icon: {
      type: Boolean,
      default: true
    },
    nav: {
      type: Boolean,
      default: true
    },
    show_user: {
      type: Boolean,
      default: false
    },
    show_logo: {
      type: Boolean,
      default: true
    }
  },
  data:() => ({
    menu_open: false,
    fav: true,
    menu: false,
    overlay: false,
    inactive_item: false,
    open_cart: false,
    flavors: [],
    drawer: false,
    group: '',
    miniVariant: false
  }),
  computed: {
    ...mapState(['cart', 'is_auth', 'user', 'data_home_page', 'number_day'])
  },
  methods: {
    goHome() {
      if (this.$route.name != 'Home') {
        this.$router.push('/')
      }
    },
    async logout() {
      try {
        this.overlay = true
        this.inactive_item = true
        await HomeService.logout()
        await this.$store.dispatch('setUser', {
          name: '',
          lastname: '',
          email: '',
          phone: '',
          role: '',
          address: ''
        })
        localStorage.removeItem('token')
        this.$store.dispatch('setSession', false)
        this.$store.dispatch('cleanCart')

        this.inactive_item = false
        if (this.$route.path != '/') {
          this.$router.push('/')
        }
        this.overlay = false
        this.menu_open = false
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
  b {
    color: var(--color-light)
  }
  >>>.v-list-item {
    padding: 0px;
    font-family: var(--font-baloo-regular);
  }
  >>>.v-list-item--dense, .v-list--dense .v-list-item {
    min-height: 30px;
  }
  .navbar-bolsa-container {
    position: absolute;
    top: -90px;
    left: 70px;
    border-radius: 50px;
  }
  @media (max-width: 425px) {
    .navbar-bolsa-container {
      left: 90px;
    }
  }
  @media (max-width: 768px) {

  }

</style>
